import { getKeyPressLength, IVROption } from '@pwp-common';

export const computeMaxDigits = (ivrOptions: IVROption[]): number => {
  const keyPressLengths = ivrOptions
    .flatMap((ivrOption) => ivrOption.getKeyPresses())
    .map((keyPress) => getKeyPressLength(keyPress));

  return Math.max(0, ...keyPressLengths);
};
